export const getMessageConfig = (item: connect.ChatTranscriptItem): connect.ListPickerMessageContent | undefined => {
  try {
    return item.Content ? (JSON.parse(item.Content) as connect.ListPickerMessageContent) : undefined;
  } catch {
    return undefined;
  }
};

export const getListPickerOptions = (item: connect.ChatTranscriptItem): connect.ListPickerItem[] | undefined => {
  return getMessageConfig(item)?.data?.content?.elements;
};
